export type AttachmentContext =
  | { mode: "none" }
  | { mode: "type"; query: string }
  | { mode: "report"; query: string };

export function getAttachmentContext(text: string): AttachmentContext {
  const reportMatch = text.match(/(^|\s)@report(?:\s+([^\n@]*))?$/i);
  if (reportMatch) {
    return { mode: "report", query: String(reportMatch[2] || "").trim().toLowerCase() };
  }

  const typeMatch = text.match(/(^|\s)@([a-z]*)$/i);
  if (typeMatch) {
    return { mode: "type", query: String(typeMatch[2] || "").toLowerCase() };
  }

  return { mode: "none" };
}
